import { ThemeUICSSObject } from 'theme-ui';
import { GetFulfillmentDelivery } from 'src/graphql/types/delivery';

export type StopNote = {
  stop: GetFulfillmentDelivery;
  note: string;
};
export const getPrintableStyle = (printable?: boolean): ThemeUICSSObject =>
  printable ? { width: '150px' } : {};
